import apiService from '../apiService';

const DetailMovementsService = {
  listDetailMovements: (params) => apiService.get('/detail-movements', params),
  getAllDetails: () => apiService.get('/detail-movements/allDetails'),
  getAllWhereNotInOutgoing: () => apiService.get('/detail-movements/allForOutgoing'),
  getDetailMovements: (id) => apiService.get(`/detail-movements/${id}`),
  createDetailMovements: (data) => apiService.post('/detail-movements', data),
  updateDetailMovements: (id, data) => apiService.put(`/detail-movements/${id}`, data),
  deleteDetailMovements: (id) => apiService.delete(`/detail-movements/${id}`),
};

export default DetailMovementsService;
